import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { util } from 'app/core/util/util';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RelocationSandbox } from 'app/core/sandboxes/relocation.sandbox';
import { FlordersFilter } from 'app/core/interfaces/florders-filter.interface';
import { Relocation } from 'app/core/interfaces/order.interface';
import { CreateRelocationsModalData } from 'app/core/store/calendar/relocations/calendar-relocations.interface';
import moment from 'moment';

@Component({
  selector: 'app-calendar-create-relocation-modal',
  templateUrl: './calendar-create-relocation-modal.component.html',
  styleUrls: ['./calendar-create-relocation-modal.component.scss'],
})
export class CalendarCreateRelocationModalComponent implements OnInit {
  isLoading = false;
  relocations: Relocation[] = [];
  title = '';

  constructor(
    private dialogRef: MatDialogRef<CalendarCreateRelocationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateRelocationsModalData,
    private sandbox: RelocationSandbox,
    private cd: ChangeDetectorRef
  ) {
    if (data.day.florderInfos.length) {
      this.loadData(data);
    }
  }

  ngOnInit() {
    // ex: 4th June 2020
    this.title = moment(this.data.day.date).format('Do MMMM YYYY');
  }

  close(createOrder: boolean, id?: string, salesOrderNumber?: string) {
    const date = util.formatDate(this.data.day.date.toDate());
    this.dialogRef.close({ createOrder, id, salesOrderNumber, date });
  }

  private async loadData(data: CreateRelocationsModalData) {
    this.isLoading = true;
    const dayFilter: FlordersFilter = {
      ...data.filter,
      unloadingDateFrom: data.day.dateString,
      unloadingDateTo: data.day.dateString,
    };

    this.relocations = await this.sandbox.loadRelocations$$(dayFilter);
    this.isLoading = false;
    this.cd.markForCheck();
  }
}
